import React, { useEffect, useState } from 'react';
import Script from 'next/script';

import { pageLoaded } from '../../../utils';

import { IThirdParty } from './types';

function usePageLoad() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    pageLoaded().then(() => setLoaded(true));
  }, []);

  return loaded;
}

function NextThirdParty({ gAnalytics4Id, gAnalyticsId, hotjarId, recaptchaSiteKey }: IThirdParty) {
  const loaded = usePageLoad();
  const attachScripts = loaded;

  if (loaded && !attachScripts) {
    console.log('>> Some third party scripts were not loaded due to environment');
  }

  return (
    <>
      {gAnalytics4Id && gAnalyticsId && (
        <Script
          id="ga-analytics"
          dangerouslySetInnerHTML={{
            __html: `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${gAnalyticsId}', {
            page_path: window.location.pathname,
          });
          gtag('config', '${gAnalytics4Id}', {
            page_path: window.location.pathname,
          });
        `,
          }}
        />
      )}

      {attachScripts && (
        <Script
          strategy="lazyOnload"
          src={`https://www.googletagmanager.com/gtag/js?id=${gAnalyticsId}`}
        />
      )}

      <Script
        id="hotjar-init"
        dangerouslySetInnerHTML={{
          __html: `
        window.hj = window.hj || function() { (window.hj.q = window.hj.q || []).push(arguments) };
        window._hjSettings={hjid:${hotjarId},hjsv:6};
          `,
        }}
      />

      {attachScripts && (
        <Script
          strategy="lazyOnload"
          src={`https://static.hotjar.com/c/hotjar-${hotjarId}.js?sv=6`}
        />
      )}

      {recaptchaSiteKey && (
        <Script
          async
          src={`https://www.google.com/recaptcha/api.js?render=${recaptchaSiteKey}`}
        ></Script>
      )}
    </>
  );
}

export default React.memo(NextThirdParty);
